import { z } from 'zod';

// Messages de validation par défaut en français, pour l'API comme pour les interfaces.
z.config(z.locales.fr());

export * from './commun';
export * from './organisations';
export * from './incidents';
export * from './interventions-reseau';
export * from './stocks';
export * from './patrimoine';
export * from './equipes-reseau';
export * from './portail-public';
export * from './couts-reseau';
export * from './incidents-cycle';
export * from './referentiels-metier';
export * from './erreurs';
export * from './auth';
export * from './habilitations';
export * from './administration';
export * from './modules-catalogue';
export * from './parametres';
export * from './workflow';
export * from './documents';
export * from './indicateurs';
export * from './notifications-catalogue';
export * from './supervision-schemas';
export * from './presentation';
export * from './ui-preferences';
export * from './investissements-reseau';
export * from './communication-reseau';
export * from './crises-reseau';
export * from './terrain-reseau';
export * from './reclamations-reseau';
export * from './instruction-investissements';
